import React from "react";
import LoanApplication from "../../../models/loan/loanApplication";
import "./OperatingLoanSection.css";
import { AgriculturalProductMeasurers, LoanType } from "../../../shared/Enums";
import Table from "react-bootstrap/esm/Table";
import NAICSCode from "models/operatingLoan/naicsCode";
import loanApplicationUtility from "utilities/LoanApplicationUtility";

interface OperatingLoanSectionProps {
  loanDetails: LoanApplication
}

export default class OperatingLoanSection extends React.Component<OperatingLoanSectionProps> {
  buildQuantityText(naicsCode: NAICSCode): string {
    return `${loanApplicationUtility.BuildAmount(naicsCode.quantity ?? 0)}`;
  }

  buildPriceText(naicsCode: NAICSCode): string {
    return `${loanApplicationUtility.BuildCurrencyAmount(naicsCode.price)}/${loanApplicationUtility.GetAgriculturalProductMeasurers((naicsCode.measurement ?? -1) as AgriculturalProductMeasurers).toLowerCase()}`.trim();
  }

  buildCollateralValueText(naicsCode: NAICSCode): string {
    return `${loanApplicationUtility.BuildCurrencyAmount((naicsCode.quantity ?? 0) * (naicsCode.price ?? 0))}`;
  }

  buildTotalValueAmount(): string {
    let totalValue = 0;

    this.props.loanDetails.operationNAICSCodes?.map((snc: NAICSCode) => {
      totalValue += (snc.quantity ?? 0) * (snc.price ?? 0);
    })

    return `Total Production Value: ${loanApplicationUtility.BuildCurrencyAmount(totalValue)}`;
  }

  buildTotalValueText(): string {
    let totalValue = 0;

    this.props.loanDetails.operationNAICSCodes?.map((snc: NAICSCode) => {
      totalValue += (snc.quantity ?? 0) * (snc.price ?? 0);
    });

    totalValue += (this.props.loanDetails.inventoryHeld?.value ?? 0);

    this.props.loanDetails.otherIncomes?.map((oi, index) => {
      totalValue += (oi.value ?? 0);
    });

    return `Total Revenues: ${loanApplicationUtility.BuildCurrencyAmount(totalValue)}`;
  }

  render() {
    return (
      <>
        {this.props.loanDetails.loanType === LoanType.OperatingLoan &&
          (<>
            <div className="loan-application-details-section">
              <h3>Operating Commodities</h3>
              <h5>{this.buildTotalValueAmount()}</h5>
              <Table bordered striped={false} size="sm">
                <tbody>
                  <tr>
                    <th>NAICS Title</th>
                    <th>NAICS Code</th>
                    <th>NAICS Quantity</th>
                    <th>NAICS Amount</th>
                    <th>Total Value</th>
                  </tr>
                  {this.props.loanDetails.operationNAICSCodes?.map(nc => {
                    return (
                      <tr>
                        <td width="250px" className="app-info"><strong>{loanApplicationUtility.BuildOtherTitle(nc)}</strong></td>
                        <td className="app-info">{nc.code}</td>
                        <td className="app-info">{this.buildQuantityText(nc)}</td>
                        <td className="app-info">{this.buildPriceText(nc)}</td>
                        <td className="app-info">{this.buildCollateralValueText(nc)}</td>
                      </tr>
                    )
                  })
                  }
                </tbody>
              </Table>
            </div>

            <div className="loan-application-details-section">
              <h3>Other Income(s)</h3>
              <Table bordered striped={false} size="sm">
                <tbody>
                  <tr>
                    <th>Description</th>
                    <th>Amount</th>
                  </tr>
                  {this.props.loanDetails.otherIncomes?.map(oi => {
                    return (
                      <tr>
                        <td width="250px" className="app-info"><strong>{oi.name}</strong></td>
                        <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(oi.value)}</td>
                      </tr>
                    )
                  })
                  }
                </tbody>
              </Table>
            </div>

            <div className="loan-application-details-section">
              <h3>Inventories Held</h3>
              <Table bordered striped={false} size="sm">
                <tbody>
                  <tr>
                    <td width="250px" className="app-info"><strong>{'Amount'}</strong></td>
                    <td className="app-info">{loanApplicationUtility.BuildCurrencyAmount(this.props.loanDetails.inventoryHeld?.value)}</td>
                  </tr>
                </tbody>
              </Table>
            </div>

            <div className="loan-application-details-section">
              <h3>{this.buildTotalValueText()}</h3>
            </div>
          </>)
        }
      </>
    );
  }
}